import { type FC, type ReactNode } from 'react';

import { useGetOrganisationForFeatureBootstrap } from '@/hooks/queries/organisation/useGetOrganisation';

import { FeaturesProviderView } from './FeaturesProviderView';

type Props = { children: ReactNode };

export const FeaturesProvider: FC<Props> = ({ children }) => {
  const { data, loading, error } = useGetOrganisationForFeatureBootstrap();

  return (
    <FeaturesProviderView
      organisation={data?.auth_organisation[0]}
      hasError={!!error}
      isLoading={loading}
    >
      {children}
    </FeaturesProviderView>
  );
};
